import styles from './DareLevels.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import { GrainOverlay } from '../shared/GrainOverlay';
import { dareLevels } from '../../data/dare-levels';

import softIcon from '../../assets/images/dares/soft.png';
import steamyIcon from '../../assets/images/dares/steamy.png';
import wildIcon from '../../assets/images/dares/wild.png';
import hardcoreIcon from '../../assets/images/dares/hardcore.png';

const icons: Record<string, string> = { soft: softIcon, steamy: steamyIcon, wild: wildIcon, hardcore: hardcoreIcon };

export function DareLevels() {
  return (
    <SectionWrapper className={styles.section}>
      <GrainOverlay />
      <div className={styles.header}>
        <Chip>Pick Your Heat</Chip>
        <h2 className={`display ${styles.title}`}>
          How far will <ScriptText rotate={-2}>you go?</ScriptText>
        </h2>
      </div>

      <div className={styles.grid}>
        {dareLevels.map((d) => (
          <div
            key={d.name}
            className={styles.card}
            style={{ '--dare-hue': d.hue } as React.CSSProperties}
          >
            <div className={styles.cardTop}>
              <div className={styles.pips}>
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className={styles.pip}
                    style={{ background: i <= d.heat ? d.hue : 'rgba(255,255,255,0.12)' }}
                  />
                ))}
              </div>
              <div className={styles.iconWrap}>
                <img src={icons[d.icon]} alt={d.name} />
              </div>
            </div>
            <h3 className={styles.name}>{d.name}</h3>
            <p className={styles.sub}>{d.sub}</p>
            <p className={styles.desc}>{d.desc}</p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
